import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import FaceAuthenApp from './FaceAuthenApp';
import FaceEnrollApp from './FaceEnrollApp';

import reportWebVitals from './reportWebVitals';
import StoreManager from './appdata';
import LanguageSDK from './languages';

import vi from './languages/vi.json'
import en from './languages/en.json'
import lang from './languages/lang.json'


var root = null;
var container = null; // Khai báo biến container ở cấp độ cao hơn để dễ dàng truy cập

function start(configEkyc, callback) {
  StoreManager.resetState()

  StoreManager.appdata.configEkyc = configEkyc
  StoreManager.appdata.callback = callback

  container = document.createElement('div');
  container.style.position = 'fixed';
  container.style.zIndex = 16777100;
  container.style.width = '100%';
  container.style.height = '100%';
  container.style.top = '0';
  container.style.left = '0';
  container.style.right = '0';
  container.style.bottom = '0';


  document.body.appendChild(container);

  root = ReactDOM.createRoot(container);
  root.render(
    <App />
  );
}

function close() {
  const tracks = StoreManager.appdata.media?.getTracks();
  tracks?.forEach((track) => {

    //   track.applyConstraints({
    //     advanced: [{ zoom: 1.0}]
    // }).then(() => {
    //     console.log('Zoom reset to default:');
    // }).catch(error => {
    //     console.error('Failed to reset zoom:', error);
    // });
    track.stop();

  });

  // console.log("tracks", tracks)
  StoreManager.appdata.media = null
  StoreManager.resetState()
  setTimeout(() => {
    if (root) {
      root.unmount();
      container.parentNode.removeChild(container); // Sau đó xóa container div
      root = null;
      container = null;
    }
  }, 500)

}

function setLanguageJson(language, json) {
  let languageVI = json.languageVI ?? vi
  let languageEN = json.languageEN ?? en
  let languageJson = language === "vi" ? languageVI : languageEN
  LanguageSDK.loadLanguageByJson(languageJson)
}

function startFaceAuthen(configFaceAuthen, callback){
    StoreManager.resetState()

    StoreManager.appdata.configFaceAuthen = configFaceAuthen
    StoreManager.appdata.callback = callback

    container = document.createElement('div');
    container.style.position = 'fixed';
    container.style.zIndex = 16777100;
    container.style.width = '100%';
    container.style.height = '100%';
    container.style.top = '0';
    container.style.left = '0';
    container.style.right = '0';
    container.style.bottom = '0';


    document.body.appendChild(container);

    root = ReactDOM.createRoot(container);
    root.render(
      <FaceAuthenApp />
    );
}

function startFaceEnroll(configFaceEnroll, callback){
    StoreManager.resetState()

    StoreManager.appdata.configFaceEnroll = configFaceEnroll
    StoreManager.appdata.callback = callback

    container = document.createElement('div');
    container.style.position = 'fixed';
    container.style.zIndex = 16777100;
    container.style.width = '100%';
    container.style.height = '100%';
    container.style.top = '0';
    container.style.left = '0';
    container.style.right = '0';
    container.style.bottom = '0';


    document.body.appendChild(container);

    root = ReactDOM.createRoot(container);
    root.render(
      <FaceEnrollApp />
    );
}


export default { start, close, setLanguageJson, startFaceAuthen, startFaceEnroll }; 